/* these can be used item.id or enchant.id */
enum GearState {
  BIS,
  Naked
}

export default GearState
